import React from 'react';
import { Link } from 'react-router-dom';
import Rating from '../Rating/Rating';
import Tag from '../Tag/Tag';
import { useDispatch } from 'react-redux';
import { addItems } from '../../features/Orders/orderSlice';
function ProductListCard({
  id,
  foodName,
  restaurantName,
  src,
  waitingTime,
  calories,
  tags,
  price,
  rating,
  food,
}) {
  const dispatch = useDispatch();

  return (
    <section className="my-10 ">
      <div className="rounded-[20px] flex  shadow-md bg-white w-[100%] h-[100%] lg:w-[648px] lg:h-[224px] overflow-hidden">
        <Link to={`/food/${id}`} className="w-[55%] sm:w-[33%]">
          <img
            className="rounded-t-[20px] object-cover object-center  hover:scale-110 hover:duration-1000 bg-cover bg-center w-full h-[224px]"
            src={src}
            alt={foodName}
          />
        </Link>
        <div className="w-[66%] flex flex-col">
          <div className="flex justify-between px-4 py-2">
            <Link
              to={`/food/${id}`}
              className="text-dark-3 hover:text-dark-2 text-[16px] sm:text-h3 font-semibold"
            >
              {foodName}
            </Link>
            <p className="text-primary-5 text-[16px]  sm:text-h3 font-bold">
              {calories} Cal
            </p>
          </div>
          <div className="flex justify-between px-4">
            <h5 className="text-dark-3 text-[12px] sm:text-h4 font-400">
              {restaurantName}
            </h5>
            <p className="text-dark-3 text-[12px]  md:text-h4 font-400">
              {waitingTime} min
            </p>
          </div>
          <div className="px-4 py-2">
            <Rating checked={rating} />
          </div>
          <div className="px-4 py-2 flex gap-[2px] md:space-x-2 flex-wrap">
            {tags && tags.map((data) => <Tag tag={data} key={data} />)}
          </div>

          <div className="flex justify-between items-center px-4 py-2">
            <h5 className="text-dark-3 text-sm sm:text-h3 font-semibold">
              ${price}
            </h5>
            <div>
              <button
                type="button"
                className=" bg-[#618639] hover:bg-primary-5  md:px-8  px-3 py-1 sm:py-2 rounded-[30px] text-[#fff] text-[12px] md:text-lg"
                onClick={() => dispatch(addItems(food))}
              >
                Add to cart
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProductListCard;
